import { useCallback } from 'react';
import { ResponseError } from 'services/api/base';
import {
  useDeleteAgroTrackingForecastPreferenceMutation,
} from 'services/api/Meteorology/Agro/TrackingForecast/DetailedView';
import { useHandleRequestErrors } from 'utils/hooks';

export default function useDeletePreference() {
  const [trigger, { isLoading, error }] = useDeleteAgroTrackingForecastPreferenceMutation();
  const preferenceDeleteTrigger = useCallback((name: string) => () => {
    trigger({ name });
  }, [trigger]);

  useHandleRequestErrors(error as ResponseError | undefined);

  return {
    preferenceDeleteTrigger,
    isLoading,
  };
}
